import { useMemo } from 'react';
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { getCompanyCurrencies } from '../api';
import {
  companyCurrenciesQueryKey,
  currencyToSelectOption,
  flattenCurrencyPages,
  getCurrencyNextPageParam,
} from '../utils/companyCurrencies';

export function useCompanyCurrencies(search = '') {
  const query = useInfiniteQuery({
    queryKey: companyCurrenciesQueryKey(search),
    queryFn: ({ pageParam = 1 }) => {
      const params = {};
      if (search) params.search = search;
      if (pageParam && Number(pageParam) !== 1) params.page = pageParam;
      return getCompanyCurrencies(params);
    },
    initialPageParam: 1,
    getNextPageParam: getCurrencyNextPageParam,
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  const currencies = useMemo(
    () => flattenCurrencyPages(query.data),
    [query.data],
  );

  const options = useMemo(
    () => currencies.map(currencyToSelectOption),
    [currencies],
  );

  return {
    currencies,
    options,
    isPending: query.isPending,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
    fetchNextPage: query.fetchNextPage,
    hasNextPage: Boolean(query.hasNextPage),
    isFetchingNextPage: query.isFetchingNextPage,
  };
}
